import React, { Component } from 'react';
import { withRouter } from 'next/router';
import { WithRouterProps } from 'next/dist/client/with-router';

import Article from 'components/Article';
import ArticleNav from 'components/ArticleNav';
import ErrorPage from 'styled/components/ErrorPage';
import { ArticleMeta as Meta } from 'components/Meta';

import { Article as IArticle, ErrorPage as IErrorPage } from 'types';

interface PassedProps {
  errorPage: IErrorPage;
  article: IArticle | null;
}

type Props = PassedProps & WithRouterProps;

class ArticlePageView extends Component<Props> {
  render() {
    const { errorPage, article } = this.props;

    if (!article) return <ErrorPage errorPage={errorPage} />;

    return (
      <div className="relative flex">
        <Meta article={article} />
        <ArticleNav className="none sm:block" article={article} />
        <Article article={article} />
      </div>
    );
  }
}

export default withRouter(ArticlePageView);
